
import Vue from "vue";

export default Vue.extend({
  name: "MovieContainer",
  props: {
    url: String,
  },
  computed: {
    youtubeUrl() {
      const { url } = this;
      if (!url) {
        return null;
      }
      const key = url.split("/").pop()?.replace("?t=", "?start=");
      return `https://www.youtube.com/embed/${key}`;
    },
  },
});
